export const aftcabinImageOptions = {
  angle: 'aftcabin',
  staticOptions: {
    Floorboard: 1,
    Handrail: 1,
    Worktop: 1,
    Fabric: 1,
    CupboardsSaloon: 1,
    CupboardsOwnersCabin: 1,
    Mast: 1
  },
  mattes: []
}



// WEBPACK FOOTER //
// ./src/X40/views/aftcabin.js